import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    titlePage: "Mes relations",
    html: {
        returnTitle: "Mon compte"
    }
};

export type I18nRelation = typeof _fr;

const _en: I18nRelation = {
    titlePage: "My relations",
    html: {
        returnTitle: "My account"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nRelation {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}